<template>
  <div :class="{'qual-notable': isLogNotable}" class="logged-note">
    <div class="qual-question" @click="showQualQuestion">
      <span class="numbering">{{ index + 1 }}. </span> <span v-html="log.question" />
    </div>
    <div class="qual-answer">
      {{ log.answer }}
      <span v-if="log.timestamp"> ({{ formatTime(log.timestamp) }})</span>
    </div>
  </div>
</template>
<script>
import { format as dateFormat, addSeconds } from 'date-fns'
export default {
  props: ['log', 'index', 'qualNotable'],
  computed: {
    isLogNotable: function () {
      var that = this
      if (!this.qualNotable.length) {
        return false
      }
      var isNotable = this.qualNotable.findIndex(function (notable) {
        return notable.questionNumber === that.index && notable.questionText === that.log.question
      }) !== -1
      return isNotable
    }
  },
  methods: {
    showQualQuestion: function ($event) {
      const textResponsesIdx = this.log.number_of_actual_insights + this.index
      this.$emit('selectInsight', textResponsesIdx)
    },
    formatTime: function (ts) {
      const helperDate = addSeconds(new Date(0), ts)
      return dateFormat(helperDate, 'm:ss')
    }
  }
}
</script>
<style scoped>
  .qual-question {
    font-weight: bold;
    cursor: pointer;
  }

  .qual-question:hover {
    text-decoration: underline;
  }
</style>
